import React from 'react';
import { Row, Button, Col, Spinner } from 'react-bootstrap';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

import { dateFormatUtil ,getFormattedDateTime,getFormattedDate} from '../Utilities';
import Form from 'react-bootstrap/Form';
import MaterialTable from 'material-table';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { withAuthorization } from '../Session';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';

import ProfileWalletTransaction from '../Profile/ProfileWalletTransaction';
import ProfileWalletLinks from '../Profile/ProfileWalletLinks';
import ProfileWalletWithdraw from '../Profile/ProfileWalletWithdraw';
import ProfileWalletDeposit from '../Profile/ProfileWalletDeposit';


import queryString from 'query-string';

class ProfileWallet extends React.Component {
    _isMounted = false;

    state = {
        backArrow: false,
        currentTotalBalance: 0,
        profileDocId:'',
        defaultActiveKey:'walletTransaction',
        loading:true,
    };

    dataArray = [];

    afterDeposit=()=>{
        this.loadBalance()
    }
    async loadBalance() {
        let dataRow = {
            UniqeID: this.props.UniqeID,
            UserRole: this.props.selectedUserRole
        };
        await RestServices.getProfileDetail(
            localStorage.getItem('FirebaseToken'),
            dataRow
        )
            .then((response) => response.json())
            .then((responseData) => {
                
             if (this._isMounted) {
                        this.setState({
                            loading:false,
                            profileDocId: responseData.data.profileDocId,
                            currentTotalBalance: responseData.data.walletbalance?responseData.data.walletbalance:0,
                        });
                    }
            })
    }

    async componentDidMount() {
        
        this._isMounted = true;
        this.loadBalance()
    }

    componentWillUnmount() {
        this._isMounted = false;
    }
    changeTab=()=>{
        this.setState({
            loading:true,
        });
        setTimeout(() => {
        this.setState({
            loading:false,
        });
    }, "50")
     
    }
    
    

    
    render() {
        return (
            <div>
                <Row
                    style={{
                        marginBottom: '1rem',
                        justifyContent: 'space-between',
                        display: 'flex',
                        flexDirection: 'row',
                        textAlign: 'left'
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            margin: '0.5rem'
                        }}
                    >
                        <p></p>
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            margin: '0.5rem'
                        }}
                    >
                        <p>
                           Wallet Balance: ₹{' '}
                            {parseFloat(this.state.currentTotalBalance).toFixed(2)}
                        </p>
                        
                    </div>
                </Row>

                <Tabs
                    defaultActiveKey={this.state.defaultActiveKey}
                    id="uncontrolled-tab-example"
                    onClick={()=>this.changeTab()}
                >
                    <Tab eventKey="walletTransaction" title="Transaction">
                    <div>
                            <hr />
                    </div>
                       
                    {!this.state.loading &&<ProfileWalletTransaction {...this.props}/>}
                    
                    </Tab>

                    <Tab eventKey="walletLinks" title="Links">
                    <div>
                            <hr />
                    </div>
                    {!this.state.loading &&<ProfileWalletLinks  {...this.props} />}
                        
                    </Tab>

                    <Tab eventKey="walletWithdraw" title="Make a Debit">
                    <div>
                            <hr />
                    </div>
                    {!this.state.loading &&<ProfileWalletWithdraw afterWithdraw={this.afterDeposit}  userProfileDocId={this.state.profileDocId} currentTotalBalance={this.state.currentTotalBalance} {...this.props} />}
                    </Tab>

                    <Tab eventKey="walletDeposit" title="Make a Credit">
                    <div>
                            <hr />
                            
                    </div>
                    {!this.state.loading &&<ProfileWalletDeposit afterDeposit={this.afterDeposit} userProfileDocId={this.state.profileDocId}  currentTotalBalance={this.state.currentTotalBalance} {...this.props} />}
                    </Tab>

                    
                    
                    
                    
                </Tabs>

                
            </div>
        );
    }
}

export default ProfileWallet;
